// extracted by mini-css-extract-plugin
module.exports = {"sk_loader":"SkeletonLoader_sk_loader__3U8X3","skeleton_box":"SkeletonLoader_skeleton_box__11rEc","shimmer":"SkeletonLoader_shimmer__4m4YU"};